import { contextConnect, useContextSystem } from '@wp-g2/context';
import React from 'react';
import { CardBody } from '../Card';

var ModalBody = function (props, forwardedRef) {
  var otherProps = useContextSystem(props, 'ModalBody');
  return /*#__PURE__*/React.createElement(CardBody, Object.assign({}, otherProps, {
    ref: forwardedRef
  }));
};

export default contextConnect(ModalBody, 'ModalBody');